'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { ICON_STROKE_MAP } from './config.mjs';

const EyeIcon = ({ size = 24, ...props }, ref) => /* @__PURE__ */ jsx(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width: size,
    height: size,
    strokeWidth: ICON_STROKE_MAP[size],
    ref,
    "aria-hidden": true,
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M12 8.99999C13.7 8.99999 15 10.3 15 12C15 13.7 13.7 15 12 15C10.3 15 8.99998 13.7 8.99998 12C8.99998 10.3 10.3 8.99999 12 8.99999ZM12 5.79999C7.99998 5.79999 4.49998 8.19999 2.79998 11.6C2.69998 11.9 2.69998 12.2 2.79998 12.5C4.49998 15.9 7.89998 18.3 12 18.3C16.1 18.3 19.5 15.9 21.2 12.5C21.3 12.2 21.3 11.9 21.2 11.6C19.5 8.09999 16 5.79999 12 5.79999Z",
        stroke: "currentColor"
      }
    )
  }
);
const VpEyeIcon = forwardRef(EyeIcon);

export { VpEyeIcon as default };
